



































































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import { BusEvent } from '../models/bus';

import Exercise from '../api/exercise';
import LockManager from '../models/lock';

import FieldAudio from '../components/FieldAudio.vue';
import FieldImage from '../components/FieldImage.vue';
import FieldTranscriptArpabet from '../components/FieldTranscriptArpabet.vue';
import FieldSentenceLinks from '../components/FieldSentenceLinks.vue';
import FieldInternational from '../components/FieldInternational.vue';
import FieldVideos from '../components/FieldVideos.vue';
import FieldPhonemes from '../components/FieldPhonemes.vue';
import FieldHints from '../components/FieldHints.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import FieldVideosI18n from '../components/FieldVideosI18n.vue';
import DropDownText from '@/components/DropDownText.vue';
import { ExerciseGameSubType, ExerciseScoringMode } from '@/api/common';
import FieldReferenceAlignments from '@/components/FieldReferenceAlignments.vue';
import FieldExtraInfo from '@/components/FieldExtraInfo.vue';
import CopyExercise from '@/components/CopyExercise.vue';
import { isEmpty } from 'lodash';
import Module from '@/api/module';
import { checkContent } from '@/api/content-check';
import { log } from 'console';

@Component({
  components: {
    'field-extra-info': FieldExtraInfo,
    'field-reference-alignments': FieldReferenceAlignments,
    'field-audio': FieldAudio,
    'field-image': FieldImage,
    'field-transcript-arpabet': FieldTranscriptArpabet,
    'field-sentence-links': FieldSentenceLinks,
    'field-international': FieldInternational,
    'field-videos': FieldVideos,
    'field-phonemes': FieldPhonemes,
    'field-hints': FieldHints,
    'edit-icon': EditIcon,
    'field-videos-i18n': FieldVideosI18n,
    'drop-down-text': DropDownText,
    'copy-exercise': CopyExercise
  }
})
export default class EditExerciseMissingCharacter extends CommonVue {
  @Prop({ type: Number }) public moduleId!: number;
  @Prop({ type: Number }) public lessonId!: number;
  @Prop({ type: Exercise }) public exercise!: Exercise;
  @Prop({ type: String, default: Module.SLUG }) public parent!: string;

  public gameSubTypeOptions = ExerciseGameSubType.OPTIONS;
  public gameSubTypePresentation = ExerciseGameSubType.PRESENTATION;
  public scoringModeOptions = ExerciseScoringMode.OPTIONS;
  public scoringModePresentation = ExerciseScoringMode.PRESENTATION;
  public isCheckAudio: boolean = undefined;

  public async beforeMount() {
    await this.load();
  }

  @Watch('exercise')
  public async load() {
    this.busy = true;
    this.error = false;

    if (this.exercise && this.exercise.id) {
      this.lockManager = new LockManager(this.EXERCISE_SLUG, this.exercise.id);
      await this.lockManager.checkStatus();
      if (this.lockManager.isBusy) {
        this.$bus.$emit(
          BusEvent.ERROR,
          'Someone else is making changes.',
          new Error(
            'Click refresh to check if they have finished their changes'
          )
        );
      }
    } else {
      this.lockManager = null;
    }

    this.busy = false;
  }

  // enter edit mode if it can get the lock
  @Watch('exercise', { deep: true })
  public async enterEditMode() {
    await this.tryToLock();
  }

  public async deleteClicked(): Promise<void> {
    if (!this.exercise || !this.exercise.id) {
      return;
    }

    this.busy = true;
    this.exercise.isDirty = false;

    try {
      if (!this.lockManager) {
        this.lockManager = new LockManager(
          this.EXERCISE_SLUG,
          this.exercise.id
        );
      }

      await this.tryToLock();

      await this.exercise.delete();

      await this.lockManager.releaseLock();

      this.busy = false;
      this.$router.push(
        `/${this.parent}/${this.moduleId}/${this.LESSON_SLUG}/${this.lessonId}/${this.EXERCISE_SLUG}`
      );
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not delete exercise', e);
    }
  }

  public async saveClicked(): Promise<void> {
    if (!this.exercise) {
      return;
    }

    this.busy = true;
    this.exercise.isDirty = false;

    try {
      this.checkMandatoryFields();

      await this.saveExercise();
      this.busy = false;

      const isContentOkay = await this.performContentCheck();
      if (!isContentOkay) return;

      this.$router.push(
        `/${this.parent}/${this.moduleId}/${this.LESSON_SLUG}/${this.lessonId}/${this.EXERCISE_SLUG}`
      );
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not save exercise', e);
    }
  }

  public generateMissingWord() {
    const original_sentence = this.exercise.speaking_content.sentence
    let convert_array = original_sentence.split(' ');

    function conver_to_object(array) {
      let new_array = []
      array.forEach((value, key) => {
        new_array.push({'idx': key, 'value': value})
      })
      return new_array
    }
    
    function mask_data_on_object(array1, array2) {
      let new_array = []
      array1.filter(element => {
        if(array2.includes(element)) {
          new_array.push({'idx': element.idx, 'value': '_'})
        } else {
          new_array.push({'idx': element.idx, 'value': element.value})
        }
      });

      return new_array
    }

    function randomSelection(originalArray, n) {
      let newArr = [];
      if (n >= originalArray.length) {
        return originalArray;
      }
      for (let i = 0; i < n; i++) {
        let newElem = originalArray[Math.floor(Math.random() * originalArray.length)];
        while (newArr.includes(newElem)) {
          newElem = originalArray[Math.floor(Math.random() * originalArray.length)];
        }
        newArr.push(newElem);
      }
      return newArr;
    }
    
    let concat_string_key_word = ""
    let concat_string_value_word = ""
    for (let index = 0; index < convert_array.length; index++) {
      let new_arr_string = convert_array[index].split("")
      let convert_arr_to_object = conver_to_object(new_arr_string)
      
      // let choose_item = convert_arr_to_object[Math.floor(Math.random()*convert_arr_to_object.length)];
      let choose_item;
      if (convert_arr_to_object.length < 5) {
        choose_item = randomSelection(convert_arr_to_object, 3)
      } else if (convert_arr_to_object.length < 8) {
        choose_item = randomSelection(convert_arr_to_object, 4)
      } else if (convert_arr_to_object.length < 10) {
        choose_item = randomSelection(convert_arr_to_object, 6)
      } else {
        choose_item = randomSelection(convert_arr_to_object, 8)
      }
      let key_str_number = ""
      let key_str_value = ""
      let missing_data_on_object = mask_data_on_object(convert_arr_to_object, choose_item)

      missing_data_on_object.map((item) => {
        key_str_number += item.value == '_' ? 0 : 1
        key_str_value += item.value
      })

      concat_string_key_word += key_str_number + ' '
      concat_string_value_word += key_str_value + ' '
    }
    this.exercise.speaking_content.sentence_mask = concat_string_key_word.slice(0, -1)
    this.exercise.speaking_content.sentence_mask_value = concat_string_value_word.slice(0, -1)
  }

  public checkMandatoryFields() {
    // Check if speaking sentence was chosen
    const words = this.exercise.speaking_content.transcript_arpabet;
    if (words === undefined || words.length < 1) {
      throw Error('Please select at least one word for your sentence.');
    }

    const missing_words = this.exercise.speaking_content.sentence_mask;
    if (missing_words === undefined || missing_words.length < 2) {
      throw Error('Missing Work can not null.');
    }
    if (missing_words.length < 2 && missing_words.length > 36) {
      throw Error('Unscrable Work limit 2 and maximum is 36 characters');
    }
  }

  public async performContentCheck() {
    const data = await Exercise.getJson(this.exercise.id);
    const result = await checkContent(data);

    if (isEmpty(result.result)) {
      return true;
    }

    this.$bus.$emit(BusEvent.ERROR, 'Could not save exercise', {
      messageItems: result.result.map((item) => ({
        message: item.message,
        key: item.word || item.sentence
      }))
    });

    return false;
  }

  public async saveExercise() {
    let lessonLockManager: LockManager;

    if (!this.exercise.id) {
      lessonLockManager = new LockManager(this.LESSON_SLUG, this.lessonId);
      await lessonLockManager.tryAcquireLock();

      // Upload exercise
      await this.exercise.save();

      // call it again to save media files of content
      await this.saveExercise();
    } else {
      if (!this.lockManager && this.exercise && this.exercise.id) {
        this.lockManager = new LockManager(
          this.EXERCISE_SLUG,
          this.exercise.id
        );
      }
      await this.tryToLock();

      if (!this.exercise.speaking_content.id) {
        this.exercise.speaking_content.parent_exercise = this.exercise.id;
        await this.exercise.speaking_content.save();
      }
      // await this.saveMediaFiles();
      await FieldHints.saveHints(
        this.exercise.speaking_content.global_hints_objects,
        this.exercise.speaking_content.id,
        'exercisespeakingcontent'
      );
      // Upload items with media ids
      // await this.exercise.updateReferenceScore();
      await this.exercise.speaking_content.save();
      await this.exercise.save();
    }

    if (this.lockManager && !this.lockManager.isAvailable) {
      await this.lockManager.releaseLock();
    }

    if (lessonLockManager) {
      await lessonLockManager.releaseLock();
    }
  }

  public async jsonView(): Promise<void> {
    this.$router.push(`/json/${this.exercise.id}`);
  }

  public async getReferenceScore(): Promise<void> {
    try {
      this.checkMandatoryFields();
      await this.exercise.updateReferenceScore();
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not update score exercise', e);
    }
  }
}
